import {StateCreator} from 'zustand'
import {TUser} from '../types/user.type'

type State = {
  user: TUser | null
}
type Action = {
  setUser: (user: TUser | null) => void
}
export type UserSlice = State & Action

const createUserSlice: StateCreator<UserSlice> = set => ({
  user: null,
  setUser: user => set({user: user}),
})

export default createUserSlice
